// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__16sdO","image":"Header_image__1o1hT","name":"Header_name__1qpjQ","info":"Header_info__2lhjr","infoRow":"Header_infoRow__qBtfa"};